import React, { useImperativeHandle, useState, forwardRef } from "react";
import { startCase } from "lodash";
import { DataGridColumnConfig } from "../types";
import { DataGridFilterInput } from "../DataGridFilterInput";
import classNames from "classnames";
import { useFilter } from "../useFilter";

export const DataGridSortModalInputs = forwardRef<
    { selectedSortBy: string | undefined; selectedSortAsc: boolean | undefined; reset: () => void },
    {
        className?: string;
        columns: DataGridColumnConfig[];
        getFilterValue: ReturnType<typeof useFilter>["getFilterValue"];
        sortBy: string;
        sortAsc: boolean;
    }
>(({ className, columns, getFilterValue, sortBy, sortAsc }, ref) => {
    const [selectedSortBy, setSelectedSortBy] = useState<typeof sortBy | undefined>(sortBy);
    const [selectedSortAsc, setSelectedSortAsc] = useState<typeof sortAsc | undefined>(sortAsc);

    useImperativeHandle(
        ref,
        () => ({
            selectedSortBy,
            selectedSortAsc,
            reset: () => {
                setSelectedSortBy(undefined);
                setSelectedSortAsc(undefined);
            },
        }),
        [selectedSortBy, selectedSortAsc]
    );

    if (!columns?.[0]) return null;

    const column = columns.map((c) => ({ ...c, value: getFilterValue(c.key) })).find((f) => f.key === selectedSortBy);

    return (
        <div className={classNames(className)}>
            <div className="text-capitalize pb-1">Sort by</div>
            <div className="d-flex gap-2">
                <DataGridFilterInput
                    column={column}
                    name="sort by"
                    placeHolder="Select..."
                    showPlaceholder
                    upperCaseValue={false}
                    inputType="select"
                    selectValues={columns.map((i) => ({ title: startCase(i.name), value: i.key }))}
                    value={selectedSortBy}
                    onChange={(value) => setSelectedSortBy(value)}
                />
                <DataGridFilterInput
                    column={column}
                    name="sort asc"
                    placeHolder="Select..."
                    inputType="select"
                    selectValues={[
                        { title: "A-Z", value: "0" },
                        { title: "Z-A", value: "1" },
                    ]}
                    value={selectedSortAsc === false ? "1" : "0"}
                    onChange={(value) => setSelectedSortAsc(value !== "1")}
                />
            </div>
        </div>
    );
});
